var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ]
    },
    [
      _vm.professional == 2
        ? _c(
            "div",
            {
              staticClass: "taxation_wrap",
              style: "height:" + (_vm.windowHeight - 100) + "px"
            },
            [
              _vm.isPrimary || _vm.isIntermediate
                ? _c(
                    "div",
                    { staticClass: "taxation_main" },
                    [
                      _vm.isPrimary ? _c("primary") : _vm._e(),
                      _vm._v(" "),
                      _vm.isIntermediate ? _c("intermediate") : _vm._e(),
                      _vm._v(" "),
                      _vm.isSenior ? _c("Senior") : _vm._e(),
                      _vm._v(" "),
                      _vm.istest ? _c("intermediate-one") : _vm._e()
                    ],
                    1
                  )
                : _c("div", { staticClass: "no_app" }, [
                    _c("img", {
                      attrs: {
                        src: require("../../../../static/images/kong.png"),
                        alt: "加载失败"
                      }
                    }),
                    _vm._v(" "),
                    _c("p", [_vm._v("暂无应用")])
                  ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.professional == 3
        ? _c(
            "div",
            {
              staticClass: "assessment_wrap",
              style: "height:" + (_vm.windowHeight - 100) + "px"
            },
            [
              _vm.isAssessment
                ? _c("valuation")
                : _c("div", { staticClass: "no_app" }, [
                    _c("img", {
                      attrs: {
                        src: require("../../../../static/images/kong.png"),
                        alt: "加载失败"
                      }
                    }),
                    _vm._v(" "),
                    _c("p", [_vm._v("暂无应用")])
                  ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.professional == 1
        ? _c(
            "div",
            {
              staticClass: "audit_wrap",
              style: "height:" + (_vm.windowHeight - 100) + "px"
            },
            [
              _vm.isAudit
                ? _c("audit")
                : _c("div", { staticClass: "no_app" }, [
                    _c("img", {
                      attrs: {
                        src: require("../../../../static/images/kong.png"),
                        alt: "加载失败"
                      }
                    }),
                    _vm._v(" "),
                    _c("p", [_vm._v("暂无应用")])
                  ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.professional == 8
        ? _c(
            "div",
            {
              staticClass: "socialmall_wrap",
              style: "height:" + (_vm.windowHeight - 100) + "px"
            },
            [
              _vm.isDS
                ? _c("socialmall")
                : _c("div", { staticClass: "no_app" }, [
                    _c("img", {
                      attrs: {
                        src: require("../../../../static/images/kong.png"),
                        alt: "加载失败"
                      }
                    }),
                    _vm._v(" "),
                    _c("p", [_vm._v("暂无应用")])
                  ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.professional == 24
        ? _c(
            "div",
            {
              staticClass: "three_capital_wrap",
              style: "height:" + (_vm.windowHeight - 100) + "px"
            },
            [
              _vm.isSZ
                ? _c("Three-capital")
                : _c("div", { staticClass: "no_app" }, [
                    _c("img", {
                      attrs: {
                        src: require("../../../../static/images/kong.png"),
                        alt: "加载失败"
                      }
                    }),
                    _vm._v(" "),
                    _c("p", [_vm._v("暂无应用")])
                  ])
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-86ebec48", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-86ebec48","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/appCenter/appCenter.vue
// module id = null
// module chunks = 